module.exports = __webpack_public_path__ + "db78bbde99d530689c6d1f6a6fb4697b.png";